// extracted by mini-css-extract-plugin
export var moreInfoSection = "index-module--moreInfoSection--1dxLu";
export var moreInfoDiv = "index-module--moreInfoDiv--3exxG";